if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");
	linkTag.setAttribute("rel", "preload");
	linkTag.setAttribute("as", "style");
	linkTag.setAttribute("onload", "this.onload=null;this.rel='stylesheet';");
	linkTag.setAttribute("type", "text/css");
	linkTag.setAttribute("crossorigin", "anonymous");
	linkTag.setAttribute("data-mfe-css-source", "shipbob_b_2_b_mini_bob_mfe");
	linkTag.setAttribute("data-mfe-dev-root", "#b_2_b_mini_bob_mfe");
	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	(function insert(linkTag) {
	              // store in window for moving to web component
	              window.sbStyles = window.sbStyles || {};
	              const attr = linkTag.getAttribute('data-mfe-css-source');
	              if (attr) {
	                window.sbStyles[attr] = window.sbStyles[attr] || [];
	                window.sbStyles[attr].push(linkTag.cloneNode(true));
	              }
	
	              // The default functionality of the insert function is to insert the link tag into the
	              // head of the document, and then `resolve` the loading promise when the onload event of
	              // link tag is invoked as shown in the code here.
	
	              // https://github.com/webpack-contrib/mini-css-extract-plugin/blob/master/src/index.js#L867-L882
	
	              // We do not want to insert the link in the head when the MFE is loaded inside a host
	              // and instead we add it to window.sbStyles which is later consumed by MFEs in their shadow roots.
	              //
	              // So we are good to go with resolving the code directly.
	              //
	              // This `resolve` function is available in the parent scope of the
	              // function which invokes this `insert` function.
	
	              let devRoot = linkTag.getAttribute('data-mfe-dev-root');
	              devRoot = devRoot.startsWith('#') ? devRoot.substring(1) : devRoot;
	
	              // if it is standalone mode
	              if (document.querySelector(`#${devRoot}`)) {
	                document.head.appendChild(linkTag);
	              } else {
	                // eslint-disable-next-line no-undef
	                resolve();
	              }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	18: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"951":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr